import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../../core/http-repository.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../nav-menu/user-company.service';
declare var $: any;

@Component({
  selector: 'select-contact-list',
  templateUrl: './select-contact-list.component.html',
  styleUrls: ['./select-contact-list.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})

export class SelectContactListComponent implements OnInit, OnDestroy {
  private contactLists: SelectContactList[] = [];
  public selectedContactList: SelectContactList[] = [];
  private searchedContactList: SelectContactList[] = [];
  private selectedContacts: Contacts[] = [];
  public isSelectedContactList: boolean = true;
  private selectedDate: string;
  private selectedCompany: number;
  private subs = new SubSink();

  @Input() onSendToAll: boolean;

  constructor(private repository: HttpRepositoryService, private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;
      
      this.subs.sink = this.repository.get<SelectContactList[]>('api/Campaign/GetContactList?companyId=' + this.selectedCompany).subscribe(resp => {
        this.contactLists = resp.data;
        this.search('');
      });
    })
  }

  private onSelect(e) {
    let isChecked = e.target.checked;
    let contactListId = e.target.id;
    let contactList = this.contactLists.find(x => x.contactListId == contactListId);

    if (isChecked) {
      this.selectedContactList.push(contactList);
    } else {
      let contactListIndex = this.selectedContactList.map(x => { return x.contactListId }).indexOf(contactList.contactListId);
      this.selectedContactList.splice(contactListIndex, 1);
    }

    this.searchedContactList.length == 0 ? this.isSelectedContactList = false : this.isSelectedContactList = true;
  }

  private search(searchStr) {
    if (this.onSendToAll || searchStr == '') {
      this.searchedContactList = this.contactLists.filter(x => x.contactListName.toLowerCase().indexOf(searchStr.toLowerCase()) !== -1);
    } else if (!this.onSendToAll && searchStr !== '') {
      let query = btoa(encodeURI(searchStr));

      this.subs.sink = this.repository.get<SelectContactList[]>('api/Campaign/Search?query=' + query).subscribe(resp => {
        let ids = resp.data.map(x => x.contactListId);
        this.searchedContactList = this.contactLists.filter(x => ids.includes(x.contactListId));
      });
    }
  }

  private filterSelectedContactList(objArr: SelectContactList[], searchId: number) {
    for (let i = 0; i < objArr.length; i++) {
      if (objArr[i].contactListId === searchId) {
        return i;
      }
    }

    return -1;
  }

  public getSelectedContactListName() {
    return this.selectedContactList.map(x => x.contactListName);
  }

  public getContactCount() {
    let count = 0;

    this.selectedContactList.forEach(cl => {
      count += cl.contactCount;
    });

    return count;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

export class SelectContactList {
  contactListId: number;
  contactListName: string;
  contactCount: number;
  contacts: Contacts[];
}

export class Contacts {
  id: number;
  email: string;
  phone: string;
}
